module.exports = __webpack_public_path__ + "img/Grappe_7.asset.a62fe38a.svg";